import { Link } from "react-router-dom";
import { hotSearch, trendingList } from "@/mocks/news";

export default function TrendingPanel() {
  return (
    <aside className="w-full">
      <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
        <div className="flex items-center justify-between px-4 md:px-5 py-4 border-b border-background-200 bg-background-100">
          <h2 className="font-heading font-black text-lg text-foreground-950 flex items-center gap-2">
            <span className="w-5 h-5 flex items-center justify-center text-primary-600">
              <i className="ri-fire-fill"></i>
            </span>
            今日热榜
          </h2>
          <span className="text-xs text-foreground-500 flex items-center gap-1">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-refresh-line"></i>
            </span>
            实时更新
          </span>
        </div>

        <ol className="divide-y divide-background-200">
          {trendingList.map((item) => (
            <li key={item.rank} className="group">
              <Link to={`/article/${item.id}`} className="flex items-start gap-3 px-4 md:px-5 py-3.5 hover:bg-background-100 transition-colors">
                <span
                  className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-md text-xs font-bold ${
                    item.rank <= 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {item.rank}
                </span>
                <span className="min-w-0 flex flex-col gap-1">
                  <span className="text-sm text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </span>
                  <span className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="text-secondary-700">{item.tag}</span>
                    <span className="flex items-center gap-1">
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-fire-line"></i>
                      </span>
                      {item.heat.toLocaleString("zh-CN")}
                    </span>
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ol>

        <div className="px-4 md:px-5 py-4 bg-background-100 border-t border-background-200">
          <p className="text-xs text-foreground-500 mb-3">大家都在搜</p>
          <div className="flex flex-wrap gap-2">
            {hotSearch.map((word) => (
              <Link
                key={word}
                to="/#trending"
                className="inline-flex items-center h-7 px-3 rounded-full bg-secondary-100 text-secondary-900 text-xs hover:bg-secondary-200 transition-colors"
              >
                {word}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </aside>
  );
}